import { gql, TypedDocumentNode } from '@apollo/client';

import {
  Media,
  MediaBulkDeleteInput,
  MediaConnection,
  MediaConnectionInput,
  MediaUpdateInput,
} from '@atom/types/media';

export const BASE_MEDIA = gql`
  fragment BaseMedia on Media {
    id
    name
    type
    fileId
    fileExtension
    location {
      type
      coordinates
    }
    description
    parentSubjectId
    subjectId
    subjectType
    folderId
    folderPath
    capturedDate
    createdDate
    createdBy {
      firstName
      lastName
    }
    updatedDate
    updatedBy {
      firstName
      lastName
    }
  }
`;

export const GET_MEDIUM: TypedDocumentNode<{ medium: Media }, { id: string }> =
  gql`
    query medium($id: ID!) {
      medium(id: $id) {
        ...BaseMedia
      }
    }
    ${BASE_MEDIA}
  `;

export const GET_MEDIA: TypedDocumentNode<
  { media: MediaConnection },
  { input: MediaConnectionInput }
> = gql`
  query media($input: MediaConnectionInput!) {
    media(input: $input) {
      totalCount
      media {
        ...BaseMedia
      }
    }
  }
  ${BASE_MEDIA}
`;

export const MEDIA_UPDATE: TypedDocumentNode<
  { mediaUpdate: Media },
  { input: MediaUpdateInput }
> = gql`
  mutation mediaUpdate($input: MediaUpdateInput!) {
    mediaUpdate(input: $input) {
      ...BaseMedia
    }
  }
  ${BASE_MEDIA}
`;

export const MEDIA_DELETE: TypedDocumentNode<
  { mediaDelete: boolean },
  { id: string }
> = gql`
  mutation mediaDelete($id: ID!) {
    mediaDelete(id: $id)
  }
`;

export const MEDIA_BULK_DELETE: TypedDocumentNode<
  { mediaBulkDelete: boolean },
  { input: MediaBulkDeleteInput }
> = gql`
  mutation mediaBulkDelete($input: MediaBulkDeleteInput!) {
    mediaBulkDelete(input: $input)
  }
`;

type MediaTotal = { totalCount: number };

export const FILES_TAB_MEDIA_TOTALS: TypedDocumentNode<
  { documents: MediaTotal; images: MediaTotal; videos: MediaTotal },
  {
    documents: MediaConnectionInput;
    images: MediaConnectionInput;
    videos: MediaConnectionInput;
  }
> = gql`
  query filesTabMediaTotals(
    $documents: MediaConnectionInput!
    $images: MediaConnectionInput!
    $videos: MediaConnectionInput!
  ) {
    documents: media(input: $documents) {
      totalCount
    }
    images: media(input: $images) {
      totalCount
    }
    videos: media(input: $videos) {
      totalCount
    }
  }
`;
